import moment from "moment/min/moment-with-locales";

import { SELECTED_SO_CODE_NZLO, 
  SELECTED_SO_CODE_FINO, SELECTED_SO_CODE_JPNO } from "../constants/soCode";
export function updateLocale(locale) {
  moment.locale(locale);
}

export function calculateAge(dob) {
  if (dob != null) {
    const birthDate = moment.utc(dob, "MM/DD/YYYY hh:mm:ss a").local().toDate();
    const todayDate = new Date();
    let ageNow = todayDate.getFullYear() - birthDate.getFullYear();
    const m = todayDate.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && todayDate.getDate() < birthDate.getDate())) {
      ageNow--;
    }
    return ageNow;
  }
  return null;
}

export function calculateAgeInMonth(dob) {
  if (dob != null) {
    const birthDate = moment.utc(dob, "MM/DD/YYYY hh:mm:ss a").local().toDate();
    const todayDate = new Date();
    const m = todayDate.getMonth() - birthDate.getMonth();
    if (m < 0) {
      return 0;
    }
    return m;
  }
  return null;
}

export function calculateAgeFromDate(dob, fromdate) {
  if (dob != null) {
    const birthDate = moment.utc(dob, "MM/DD/YYYY hh:mm:ss a").local().toDate();
    const fromDate = moment.utc(fromdate, "MM/DD/YYYY hh:mm:ss a").local().toDate();
    let ageNow = fromDate.getFullYear() - birthDate.getFullYear();
    const m = fromDate.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && fromDate.getDate() < birthDate.getDate())) {
      ageNow--;
    }
    return ageNow;
  }
  return null;
}

export function calculateAgeInMonthFromDate(dob, fromdate) {
  if (dob && fromdate) {
    const birthDate = moment(dob, "MM/DD/YYYY hh:mm:ss a").toDate();
    const fromDate = moment
      .utc(fromdate, "MM/DD/YYYY hh:mm:ss a")
      .local()
      .toDate();
    let months;
    months = (fromDate.getFullYear() - birthDate.getFullYear()) * 12;
    months -= birthDate.getMonth();
    months += fromDate.getMonth();
    return months <= 0 ? 0 : months;
  }
  return null;
}

export function convertStringToLocalTime(stringdate) {  
  if (stringdate != null) {
    const localdate = moment.utc(stringdate, "MM/DD/YYYY hh:mm:ss a").local().toDate();
    return localdate;
  }
  return null;
}

export function convertDateToString(date, format) {
  if (date != null && format != null) {
    const formatteddate = moment(date).format(format);
    return formatteddate;
  }
  return null;
}

export function getFeedDateFormat(date, soCode) {
  const dateFormat = soCode && soCode === SELECTED_SO_CODE_JPNO? "YYYY年MM月DD日" : "D MMMM Y";
  if (date != null) {
    const formattedDate = moment(date).format(dateFormat);
    return formattedDate;
  }
  return null;
}

export function getDateInBetween(dob, afterdays, beforedays) {
  if (dob != null) {
    let birthdayObj = null;
    const birthDate = moment.utc(dob, "MM/DD/YYYY hh:mm:ss a").local().toDate();
    birthDate.setFullYear(new Date().getFullYear());
    const isBirthdayInBetween = moment(new Date()).isBetween(moment(birthDate).subtract(beforedays, "days"), moment(birthDate).add(afterdays, "days"));
    if (isBirthdayInBetween) {
      if (birthDate < new Date()) {
        const birthday = convertDateToString(birthDate, "MM/DD/YYYY hh:mm:ss a");
        const age = calculateAge(dob);
        const birthdayformat = convertDateToString(birthDate, "DD MMMM");
        birthdayObj = {
          isBirthdayOver: true, date: birthday, age, birthdayformat,
        };
      }
      if (birthDate.getDate() == new Date().getDate()
        && (birthDate.getMonth() + 1) == (new Date().getMonth() + 1)
        && birthDate.getFullYear() == new Date().getFullYear()) {
        const age = calculateAge(dob);
        const today = convertDateToString(new Date(), "MM/DD/YYYY hh:mm:ss a");
        birthdayObj = {
          isBirthdayToday: true, date: today, age,
        };
      } else if (birthDate > new Date()) {
        const age = calculateAge(dob);
        const today = convertDateToString(new Date(), "MM/DD/YYYY hh:mm:ss a");

        const msdiff = ((birthDate.getTime() - new Date().getTime()));
        const daydiff = Math.floor(msdiff / (1000 * 60 * 60 * 24));
        birthdayObj = {
          isBirthdaySoon: true, date: today, age, daydiff
        };
      }
    }
    return birthdayObj;
  }
  return false;
}

export function getCurrentTimeInMilliSec() {
  const formatteddate = moment().valueOf();
  return formatteddate;
}

export function getFormattedLocaleTime(dateValue, format) {
  if (dateValue && format) {
  const localdate = moment.utc(dateValue, "MM/DD/YYYY hh:mm:ss a").local().toDate();
    const formatteddate = moment(localdate).format(format);
    return formatteddate;
  }
  return null;
}

export function getMonthDifference(dateValue) {
  if (dateValue) {
    const localdate = moment.utc(dateValue, "MM/DD/YYYY hh:mm:ss a").local().toDate();
    const monthDifference = moment().diff(new Date(localdate), "months", true);
    return monthDifference;
  }
  return null;
}

export function getMinutesDifferenceFromUnix(unixDateValue) {
  if (unixDateValue) {
    const localdate = moment.unix(unixDateValue);
    const minutesDiff = moment().diff(new Date(localdate), "minutes", true);
    return minutesDiff;
  }
  return null;
}

export function getLocalDateFromMillisecond(millisecond) {
  if (millisecond) {
    const localdate = moment(millisecond).local().toDate();
    return localdate;
  }
  return null;
}

export function addMonths(localdate, month) {
  if (localdate) {
    const timeupdated = moment(localdate).add(month, "M");
    return timeupdated;
  }
  return null;
}

export function addMinutes(time, mins) {
  if (time) {
    var updatedTime = moment(time, "h:mm a")
      .add(mins, "minutes")
      .format("h:mm a");
    return updatedTime;
  }
  return null;
}

export function sortByDate(array, sortBy) {
  let sortedarr = array.sort(function (a, b) {
    var c = new Date(a.data[sortBy] ? a.data[sortBy] : 0);
    var d = new Date(b.data[sortBy] ? b.data[sortBy] : 0);
    return d - c;
  });
  return sortedarr;
}

export function getYearFromDate(date) {
  if (date) {
    const year = moment(date, "MM/DD/YYYY hh:mm:ss a").year()
    return year;
  }
  return null;
}

export function getDaysDifference(dateValue) {
  if (dateValue) {
    let currentYear = moment().year();
    dateValue = moment(dateValue).year(currentYear);
    const localdate = moment(dateValue, "MM/DD/YYYY");
    const daysDifference = moment().diff(new Date(localdate), "days");
    const isBefore = moment(localdate, "YYYY/MM/DD").isBefore(moment());
    return { daysDifference, isBefore };
  }
  return null;
}

// code for auto date
export function writeMessageDateFormat(date, so = "NZLO") {
  let formatteddate = null;
  if (date != null && moment(date).isValid()) {
    switch (so) {
      case "NZLO":
        formatteddate = moment(date).format("MMMM DD, YYYY | hh:mma");
        break;
      case "FINO":
        formatteddate = moment(date).format("DD.M.YYYY | HH:mm");
        break;
      case "AUTO":
        formatteddate = moment(date).format("DD,MMM.,YYYY | HH:mm") + " Uhr";
        break;
      case "JPNO":
        formatteddate = moment(date).format("YYYY/MM/DD");
        break;
      default:
        formatteddate = moment(date).format("DD MMMM Y");
        break;
    }
  }
  return formatteddate;
}
//end

export function formatBirthDate(dateString) {
  const now = moment(dateString, ["DD/MM/YYYY", "DD-MM-YYYY", "YYYY/MM//DD", "YYYY-MM-DD"]).format("Do MMMM YYYY");
  return now;
}

export function diffYMDHMS(d1, d2) {
  // get total seconds between the times
  var _delta = !isNaN(new Date(d1) - new Date(d2)) ? (new Date(d1) - new Date(d2)).toFixed(2) / 1000 : 0;

  // calculate (and subtract) whole days
  var _days = Math.floor(_delta / 86400);
  _delta -= _days * 86400;

  // calculate (and subtract) whole hours
  var _hours = Math.floor(_delta / 3600) % 24;
  _delta -= _hours * 3600;

  // calculate (and subtract) whole minutes
  var _minutes = Math.floor(_delta / 60) % 60;
  _delta -= _minutes * 60;

  // what's left is seconds
  var _seconds = _delta % 60;  // in theory the modulus is not required

  return { days: _days, hours: _hours, minutes: _minutes, seconds: _seconds };
}

export const convertToLocaleDate = (date) => {
  const dateObj = (date && date !== "") ? new Date(date) : new Date();
  return dateObj.toLocaleString("en-US", {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    hour12: true,
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  })
}

export const formatChosenRevealDate = (revealDate, soCode) => {
      const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
  if(soCode===SELECTED_SO_CODE_NZLO) {
    return `${months[new Date(revealDate).getMonth()]} ${new Date(revealDate).getDate()}`
  }
  else if(soCode===SELECTED_SO_CODE_FINO) {
    return formatDateToDDMMYYYY(revealDate)
  }
}
export const formatDateToDDMMYYYY = (date) => {
  if(date){
    return moment(date, "MM/DD/YYYY hh:mm:ss A").format("DD.MM.YYYY");
  }
 return null;

}
export const getTimeZoneString = (date, soCode) => {
  if (date && soCode === SELECTED_SO_CODE_NZLO) {
     return date.replace(
        "12:00:00 AM",
        "7:00:00 PM GMT+13",
      )
  } else if (date && soCode === SELECTED_SO_CODE_FINO) {
    return date.replace(
        "12:00:00 AM",
        "8:00:00 AM GMT+2",
      )
  }
}